module.exports = __webpack_public_path__ + "img/newPeoplebiaoti.645edb69.png";